<ng-container *transloco="let t">
  <ul class="side-menu">
    <app-navigation class="ml-3"></app-navigation>
  </ul>
</ng-container>
